import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.0043 0.590088L2.00015 0.585938L0.585938 2.00015L3.82053 5.23475C3.61336 5.78365 3.5 6.37859 3.5 7C3.5 9.76142 5.73858 12 8.5 12C9.12141 12 9.71635 11.8866 10.2653 11.6795L12.6244 14.0386C12.4198 14.0131 12.2115 14 12 14H5C2.23858 14 0 16.2386 0 19V21H17V19C17 18.7885 16.9869 18.5802 16.9614 18.3756L22.0002 23.4144L23.4101 22.0045L2 0.594389L2.0043 0.590088Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.9126 11.6785L15.819 11.5849L16.3002 10.7479C16.431 10.5206 16.4998 10.2629 16.4999 10.0007C16.5 9.73847 16.4313 9.48079 16.3008 9.25336L15.8029 8.38612L17.5374 7.39035L18.0353 8.2576C18.3399 8.78826 18.5001 9.38952 18.4999 10.0014C18.4997 10.6133 18.3391 11.2144 18.034 11.7449L17.5355 12.6118L15.9126 11.6785Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.1286 8.89455L6.60545 2.37141C7.18976 2.13199 7.82947 2 8.5 2C11.2614 2 13.5 4.23858 13.5 7C13.5 7.67053 13.368 8.31024 13.1286 8.89455Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.0703 6.51519L20.5724 5.64795L18.8379 6.64371L19.3358 7.51096C19.771 8.26904 19.9999 9.12798 19.9995 10.0021C19.9992 10.8763 19.7698 11.735 19.334 12.4928L18.8355 13.3597L20.5693 14.3567L21.0678 13.4898C21.6779 12.4289 21.9991 11.2266 21.9995 10.0028C22 8.77903 21.6796 7.57652 21.0703 6.51519Z"}}]};

const UserTalkOff1Filled = Vue.extend<IconProps>({
  name: 'UserTalkOff1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'user-talk-off-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UserTalkOff1Filled;
